import { createContext } from 'react';

const JoyrideContext = createContext({
  isJoyrideActive: false,
  setJoyride: active => {},
});

export default JoyrideContext;
